import React, { useState } from "react";
import Container from "components/container";
import { RegisterServices } from "apis/Services/RegisterService";
import Modal from "antd/es/modal/Modal";
import { Button, message, Switch, Tooltip } from "antd";
import { Form, Input, Popconfirm, Table, Typography } from "antd";
import moment from "moment";
import * as XLSX from "xlsx";
import { saveAs } from "file-saver";
import { RegisterForm } from "./register-form";
import { EditableCell } from "./editable-cell";
import { CreateNewClient } from "./create-new-client";
import { ConfirmForm } from "./confirm-form";
import { ExpandedRowRender } from "./expanded-row-render";
import Subscriptions from "./subscriptions";
import {
  DeleteOutlined,
  ExclamationCircleOutlined,
  ReloadOutlined,
} from "@ant-design/icons";
import styles from "./registering.module.css";

// Responsible for displaying all components
function RegisterClient() {
  const [isLoading, setIsLoading] = useState(false);
  const [isTableLoading, setIsTableLoading] = useState(false);
  const [isError, setIsError] = useState(false);
  const [isAuthenticated, setIsAuthenticated] = useState(false);
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const [data, setData] = useState();
  const [newClientData, setNewClientData] = useState(null);
  const [actionType, setActionType] = useState("");

  const [isModalOpen, setIsModalOpen] = useState(false);
  const [isCreateClientModalOpen, setIsCreateClientModalOpen] = useState(false);
  const [form] = Form.useForm();
  const [editingKey, setEditingKey] = useState("");
  const [updatedData, setUpdatedData] = useState([]);

  const [subscriptions, setSubscriptions] = useState({});

  const [activeTab, setActiveTab] = useState("projects");

  const { confirm } = Modal;

  const showModal = () => {
    setIsModalOpen(true);
  };

  const showCreateClientModal = () => {
    setIsCreateClientModalOpen(true);
  };
  const handleCancel = () => {
    setIsCreateClientModalOpen(false);
  };

  // gets clients and reloads table
  async function getClients() {
    setIsLoading(true);
    let ReqObj = {
      username,
      password,
    };
    try {
      const res = await RegisterServices.getRegisteredClients(ReqObj);
      const keyedData = res.map((item, index) => ({
        ...item,
        key: item.companyID + index + 7 + item.projectID,
      }));

      setData(keyedData);
      // setData(keyedData);
      setIsAuthenticated(true);
      setIsError(false);
      setIsModalOpen(false);
    } catch (err) {
      setIsError(true);
    } finally {
      setIsLoading(false);
      setIsTableLoading(false);
    }
  }

  async function getClientSubscriptions() {
    setIsLoading(true);
    let ReqObj = {
      username,
      password,
    };
    try {
      const res = await RegisterServices.getClientSubscriptions(ReqObj);

      // console.log(res, "SUBSCRIPTIONSSS");

      setSubscriptions(res);
      setIsAuthenticated(true);
      setIsError(false);
      setIsModalOpen(false);
    } catch (err) {
      setIsError(true);
    } finally {
      setIsLoading(false);
      setIsTableLoading(false);
    }
  }

  // create new clients
  async function registerNewClient(newClientData) {
    setIsLoading(true);
    setIsTableLoading(true);
    let ReqObj = {
      clientEmail: newClientData.email,
      clientFirstName: newClientData.firstName,
      clientLastName: newClientData.lastName,
      clientPhoneNumber: newClientData.phoneNumber,
      companyName: newClientData.companyName,
      projectName: newClientData.projectName,
      companyAddress: newClientData.companyAddress,
      companyID: newClientData.companyID,
      projectID: newClientData.projectID,
      registrationDate: newClientData.registrationDate,
      expirationDate: newClientData.expirationDate,
    };
    try {
      const res = await RegisterServices.registerNewClient(
        username,
        password,
        ReqObj
      );
      setIsAuthenticated(true);
      setIsError(false);
      setIsModalOpen(false);
    } catch (err) {
      setIsAuthenticated(false);
      setUsername("");
      setPassword("");
    } finally {
      getClients();
      getClientSubscriptions();
      setIsLoading(false);
      newClientData(null);
    }
  }

  // update existing clients
  async function updateRegisteredClient(newClientData) {
    setIsLoading(true);
    setIsTableLoading(true);
    let ReqObj = {
      clientEmail: newClientData.registeredEmail,
      clientFirstName: newClientData.firstName,
      clientLastName: newClientData.lastName,
      clientPhoneNumber: newClientData.phoneNumber,
      companyName: newClientData.companyName,
      projectName: newClientData.projectName,
      companyAddress: newClientData.companyAddress,
      companyID: newClientData.companyID,
      projectID: newClientData.projectID,
      registrationDate: newClientData.dateRegistered,
      expirationDate: newClientData.expirationDate,
    };
    try {
      const res = await RegisterServices.updateRegisteredClient(
        username,
        password,
        ReqObj
      );
      setIsAuthenticated(true);
      setIsError(false);
      setIsModalOpen(false);
    } catch (err) {
      setIsAuthenticated(false);
      setUsername("");
      setPassword("");
    } finally {
      getClients();
      getClientSubscriptions();
      setIsLoading(false);
      setIsTableLoading(false);
      newClientData(null);
    }
  }

  // delete client
  async function deleteRegisteredClient(newClientData) {
    setIsLoading(true);
    setIsTableLoading(true);
    let ReqObj = {
      clientEmail: newClientData.registeredEmail,
      clientFirstName: newClientData.firstName,
      clientLastName: newClientData.lastName,
      clientPhoneNumber: newClientData.phoneNumber,
      companyName: newClientData.companyName,
      projectName: newClientData.projectName,
      companyAddress: newClientData.companyAddress,
      companyID: newClientData.companyID,
      projectID: newClientData.projectID,
      registrationDate: newClientData.dateRegistered,
      expirationDate: newClientData.expirationDate,
    };
    try {
      const res = await RegisterServices.deleteRegisteredClient(
        username,
        password,
        ReqObj
      );
      setIsAuthenticated(true);
      setIsError(false);
      setIsModalOpen(false);
    } catch (err) {
      setIsAuthenticated(false);
      setUsername("");
      setPassword("");
    } finally {
      getClients();
      getClientSubscriptions();
      setIsLoading(false);
      newClientData(null);
    }
  }

  const handleSubmit = (e) => {
    e.preventDefault();
    getClients();
    getClientSubscriptions();

    setIsError(false);
  };

  // Handles submission of client creation form
  const handleClientSubmit = (formData) => {
    setNewClientData(formData);
    setIsCreateClientModalOpen(false);
    registerNewClient(formData);
  };

  const handleEditSubmit = (formData) => {
    setNewClientData(formData);
    updateRegisteredClient(formData);
  };

  const handleDelete = (formData) => {
    setNewClientData(formData);

    setActionType("deleteClient");
    showModal();
  };

  const handleActions = (e) => {
    e.preventDefault();
    setIsModalOpen(false);

    // add CHECK if actionType is create new client
    if (actionType === "createNewClient") {
      registerNewClient(newClientData);
    } else if (actionType === "editClient") {
      updateRegisteredClient(newClientData);
    } else if (actionType === "deleteClient") {
      deleteRegisteredClient(newClientData);
    }
  };

  // TABLE FUNCTIONS
  const isEditing = (record) => record.key === editingKey;
  const edit = (record) => {
    form.setFieldsValue({
      // name: "",
      // age: "",
      // address: "",
      ...record,
    });
    setEditingKey(record.key);
  };
  const cancel = () => {
    setEditingKey("");
  };

  const save = async (record) => {
    try {
      const row = await form.validateFields();
      const newData = [...data];
      const index = newData.findIndex((item) => record.key === item.key);

      record.companyName = row.companyName;
      record.projectName = row.projectName;
      record.dateRegistered = row.dateRegistered;
      record.expirationDate = row.expirationDate;

      // Compare the dates before submitting
      const dateRegistered = moment(record.dateRegistered);
      const expirationDate = moment(record.expirationDate);

      if (
        expirationDate.isValid() &&
        dateRegistered.isValid() &&
        expirationDate.isBefore(dateRegistered)
      ) {
        // Show error message to the user
        alert("Expiration Date should be after Registration Date");
        return;
      }

      handleEditSubmit(record);
      // console.log(record, "HERE?");

      if (index > -1) {
        const item = newData[index];
        newData.splice(index, 1, {
          ...item,
          ...row,
        });
        setUpdatedData(newData);
        setEditingKey("");
      } else {
        newData.push(row);
        setUpdatedData(newData);
        setEditingKey("");
      }
    } catch (errInfo) {
      console.log("Validate Failed:", errInfo);
    }
  };

  const deleteClient = async (record) => {
    const newData = [...data];
    const index = newData.findIndex((item) => record.key === item.key);

    handleDelete(record);
  };

  // wipe projects
  async function clearProcurementLogForProject(record) {
    confirm({
      title: "Are you sure you want to wipe this project?",
      icon: <ExclamationCircleOutlined />,
      content: `This action will permanently delete all procurement logs for "${record.projectName}" (${record.companyName}).`,
      okText: "Yes, wipe it",
      okType: "danger",
      cancelText: "Cancel",
      onOk: async () => {
        let ReqObj = {
          companyID: record.companyID,
          projectID: record.projectID,
          username,
          password,
        };
        try {
          const res = await RegisterServices.clearProcurementLogForProject(
            ReqObj
          );
          message.success("Project wiped successfully!");
          setIsAuthenticated(true);
        } catch (err) {
          message.error("Failed to wipe project, please try again.");
        }
      },
    });
  }

  const columns = [
    {
      title: "First Name",
      dataIndex: "firstName",
      editable: false,
    },
    {
      title: "Last Name",
      dataIndex: "lastName",
      editable: false,
    },
    {
      title: "Phone Number",
      dataIndex: "phoneNumber",
      editable: false,
    },
    {
      title: "Address",
      dataIndex: "companyAddress",
      editable: false,
    },
    {
      title: "Email",
      dataIndex: "registeredEmail",
      editable: false,
    },
    {
      title: "Company ID",
      dataIndex: "companyID",
      editable: false,
    },
    {
      title: "Project ID",
      dataIndex: "projectID",
      editable: false,
    },
    {
      title: "Company Name",
      dataIndex: "companyName",
      editable: true,
    },
    {
      title: "Project Name",
      dataIndex: "projectName",
      editable: true,
    },
    {
      title: "Date Registered",
      dataIndex: "dateRegistered",
      editable: true,
      sorter: (a, b) => new Date(a.dateRegistered) - new Date(b.dateRegistered),
    },
    {
      title: "Expiration Date",
      dataIndex: "expirationDate",
      editable: true,
      sorter: (a, b) => new Date(a.expirationDate) - new Date(b.expirationDate),
    },

    {
      title: "Action",
      dataIndex: "operation",
      render: (_, record) => {
        const editable = isEditing(record);
        return editable ? (
          <span>
            <Typography.Link
              onClick={() => save(record)}
              style={{
                marginRight: 8,
              }}
            >
              Save
            </Typography.Link>
            <Popconfirm title="Sure to cancel?" onConfirm={cancel}>
              <a>Cancel</a>
            </Popconfirm>
          </span>
        ) : (
          <span>
            <Typography.Link
              disabled={editingKey !== ""}
              onClick={() => edit(record)}
            >
              Edit
            </Typography.Link>
            <Typography.Link
              disabled={editingKey !== ""}
              style={{
                marginLeft: 10,
                color: editingKey === "" ? "red" : "#BBBBBB",
              }}
              onClick={() => deleteClient(record)}
            >
              {/* Delete */}
              <Tooltip title="Delete">
                <DeleteOutlined />
              </Tooltip>
            </Typography.Link>
            <Typography.Link
              disabled={editingKey !== ""}
              style={{
                marginLeft: 10,
                color: editingKey === "" ? "red" : "#BBBBBB",
              }}
              onClick={() => clearProcurementLogForProject(record)}
            >
              RESET
              {/* <ReloadOutlined /> */}
            </Typography.Link>
          </span>
        );
      },
      width: "10%",
    },
  ];
  const mergedColumns = columns.map((col) => {
    if (!col.editable) {
      return col;
    }
    return {
      ...col,
      onCell: (record) => ({
        record,
        inputType:
          col.dataIndex === "expirationDate" || "dateRegistered"
            ? "date"
            : "text",
        dataIndex: col.dataIndex,
        title: col.title,
        editing: isEditing(record),
      }),
    };
  });

  const exportToExcel = (data, fileName = "table_data.xlsx") => {
    // Define the column order and headers as seen in your table
    const exportColumns = [
      { header: "First Name", key: "firstName" },
      { header: "Last Name", key: "lastName" },
      { header: "Phone Number", key: "phoneNumber" },
      { header: "Address", key: "companyAddress" },
      { header: "Email", key: "registeredEmail" },
      { header: "Company ID", key: "companyID" },
      { header: "Project ID", key: "projectID" },
      { header: "Company Name", key: "companyName" },
      { header: "Project Name", key: "projectName" },
      { header: "Date Registered", key: "dateRegistered" },
      { header: "Expiration Date", key: "expirationDate" },
    ];

    // Map and format the data to match the column order
    const formattedData = data.map((row) => {
      const formattedRow = {};
      exportColumns.forEach((col) => {
        formattedRow[col.header] = row[col.key] || "";
      });
      return formattedRow;
    });

    const worksheet = XLSX.utils.json_to_sheet(formattedData, {
      header: exportColumns.map((c) => c.header),
    });

    // Optional: Style the header row (bold) using cell object notation
    const range = XLSX.utils.decode_range(worksheet["!ref"]);
    for (let C = range.s.c; C <= range.e.c; ++C) {
      const cellAddress = XLSX.utils.encode_cell({ r: 0, c: C });
      if (!worksheet[cellAddress]) continue;
      worksheet[cellAddress].s = {
        font: { bold: true },
        alignment: { horizontal: "center" },
      };
    }

    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, "Clients");

    const excelBuffer = XLSX.write(workbook, {
      bookType: "xlsx",
      type: "array",
      cellStyles: true,
    });

    const blob = new Blob([excelBuffer], { type: "application/octet-stream" });
    saveAs(blob, fileName);
  };

  return (
    <Container
      className={`mt-4 ${styles.page}`}
      style={{ width: "100%", maxWidth: "100%" }}
    >
      {!isAuthenticated && (
        <RegisterForm
          username={username}
          password={password}
          isLoading={isLoading}
          isError={isError}
          setUsername={setUsername}
          setPassword={setPassword}
          handleSubmit={handleSubmit}
        />
      )}

      {isAuthenticated && (
        <>
          <div className={styles.tabs}>
            <Button
              type={activeTab === "projects" ? "primary" : "default"}
              shape="round"
              size="large"
              onClick={() => setActiveTab("projects")}
            >
              Projects
            </Button>
            <Button
              type={activeTab === "Warehouse" ? "primary" : "default"}
              shape="round"
              size="large"
              onClick={() => setActiveTab("Warehouse")}
            >
              Subscriptions
            </Button>
          </div>

          {activeTab === "projects" && (
            <Container
              className={`mt-4 ${styles.section}`}
              style={{ width: "100%", maxWidth: "100%" }}
            >
              <div className={styles.sectionHeader}>
                <h3 className="fw-bold mb-0">Projects</h3>
                <div className={styles.headerActions}>
                  <Button
                    onClick={() => exportToExcel(data)}
                  >
                    Export
                  </Button>
                  <Button
                    onClick={showCreateClientModal}
                    type="primary"
                  >
                    + New Client
                  </Button>
                </div>
              </div>
              <Form form={form} component={false}>
                <Table
                  components={{
                    body: {
                      cell: EditableCell,
                    },
                  }}
                  bordered
                  dataSource={data}
                  columns={mergedColumns}
                  rowClassName="editable-row"
                  loading={isTableLoading}
                  className={styles.projectsTable}
                  scroll={{ x: 1800 }}
                  pagination={{
                    onChange: cancel,
                    defaultPageSize: 20,
                  }}
                />
              </Form>

              <Modal
                open={isModalOpen}
                footer={null}
                closable={false}
                wrapClassName={styles.responsiveModal}
              >
                <ConfirmForm
                  username={username}
                  password={password}
                  isLoading={isLoading}
                  isError={isError}
                  setUsername={setUsername}
                  setPassword={setPassword}
                  handleActions={handleActions}
                />
              </Modal>

              <Modal
                open={isCreateClientModalOpen}
                onCancel={handleCancel}
                footer={null}
                wrapClassName={styles.responsiveModal}
              >
                <CreateNewClient handleClientSubmit={handleClientSubmit} />
              </Modal>
            </Container>
          )}

          {activeTab === "Warehouse" && (
            <Container
              className={`mt-4 ${styles.section}`}
              style={{ width: "100%", maxWidth: "100%" }}
            >
              {
                <Subscriptions
                  data={subscriptions}
                  username={username}
                  password={password}
                  getClientSubscriptions={getClientSubscriptions}
                />
              }
            </Container>
          )}
        </>
      )}
    </Container>
  );
}

export default RegisterClient;
